<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <!-- <div slot="header" class="clearfix">
        <b>报价列表</b>
      </div> -->
      <el-form :inline="true" :model="informdata" class="demo-form-inline">
        <el-form-item label="询价信息">
          <el-input v-model="informdata.cinquiryinfo" placeholder="询价信息"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="informdata.cisreport" clearable placeholder="请选择">
            <el-option label="已提报" value="已提报"></el-option>
            <el-option label="未提报" value="未提报"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetInquiryList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border style="width: 100%;" max-height="560" class="tb-edit" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="提报状态" prop="cisreport" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.cisreport">
              <el-link type="success" v-if="scope.row.cisreport=='已提报'">{{scope.row.cisreport}}</el-link>
              <el-link type="warning" v-if="scope.row.cisreport=='未提报'">{{scope.row.cisreport}}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="curgent" label="紧急程度" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.curgent">
              <el-tag type="primary" size="small" v-if="scope.row.curgent=='普通'">{{scope.row.curgent}}</el-tag>
              <el-tag type="danger" size="small" v-if="scope.row.curgent=='紧急'" effect="dark">{{scope.row.curgent}}</el-tag>
            </span>

          </template>
        </el-table-column>
        <el-table-column label="询价单号" prop="ccode" min-width="110"></el-table-column>
        <!-- <el-table-column label="定价中心" width="120" prop="cpricing"></el-table-column> -->
        <!-- <el-table-column prop="dxjstart" label="询价开始日期" width="110">
          <template slot-scope="scope" v-if="scope.row.dxjstart">
            {{scope.row.dxjstart.substring(0,10)}}
          </template>
        </el-table-column> -->
        <el-table-column prop="dxjend" label="报价截至日期" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.dxjend">{{scope.row.dxjend.substring(0,10)}}</span>

          </template>
        </el-table-column>
        <!-- <el-table-column prop="cpricing" label="定价方式" width="110"></el-table-column> -->
        <!-- <el-table-column prop="cquotation" label="定价方式" width="110"></el-table-column> -->
        <!-- <el-table-column prop="idbjven" label="待报价厂商数" width="110"></el-table-column> -->
        <!-- <el-table-column prop="iybjven" label="已报价厂商数" width="110"></el-table-column> -->
        <!-- <el-table-column prop="cordertype" label="订单类型"></el-table-column> -->

        <!-- <el-table-column prop="cbjshow" label="报价过程显示" min-width="120"></el-table-column> -->
        <!-- <el-table-column prop="ibjnumber" label="允许报价次数" width="110"></el-table-column> -->
        <el-table-column prop="cinquiryinfo" label="询价信息描述" min-width="220"></el-table-column>
        <!-- <el-table-column prop="ixjquantity" label="询价数量" width="110"></el-table-column> -->
        <!-- <el-table-column prop="cishtsigned" label="是否签订合同" width="110"></el-table-column> -->
        <!-- <el-table-column prop="coadjcode" label="OA定价单号" min-width="110"></el-table-column>
        <el-table-column prop="iordernum" label="订单数量" width="100"></el-table-column> -->
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
      <div style="clear:both"></div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      informdata: {
        // 询价单号
        cinquiryinfo: "",
        cisreport: "",
      },
      tableData: [],
      urid: "",
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    this.urid = window.localStorage.getItem("token");
    if (this.$route.query.informdata) {
      console.log(JSON.stringify(this.$route.query.informdata));
      if (this.$route.query.informdata.cinquiryinfo != undefined) {
        console.log(JSON.stringify(this.$route.query.informdata));
        this.informdata = {};
        this.informdata = this.$route.query.informdata;
      }
    }
    // console.log(this.informdata, "1111");
    this.GetInquiryList();
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInquiryList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInquiryList();
    },
    // 获取信息
    GetInquiryList() {
      this.informdatanew = JSON.parse(JSON.stringify(this.informdata));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInquiryList",
        data: {
          cinquiryinfo: this.informdata.cinquiryinfo,
          cisreport: this.informdata.cisreport,
          pageSize: this.pageSize,
          pageNum: this.pageIndex,
          sortField: "dcreatetime",
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        this.loading = false;
        if (res.data.Success) {
          this.tableData = res.data.Data.dt;
          this.totalCount = res.data.Data.recordCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    supedit(row) {
      // console.log(row.cquotation, row);

      if (row.cfbwl == "是") {
        this.$router.push({
          name: "SupInvoiceaddFB",
          params: { rows: row, informdata: this.informdatanew },
        });
      } else {
        if (row.cquotation == "单一报价") {
          this.$router.push({
            name: "SupInvoiceadd",
            params: { rows: row, informdata: this.informdatanew },
          });
        } else {
          if (row.cpricing == "集中定价") {
            this.$router.push({
              name: "SupInvoiceaddcont",
              params: { rows: row, informdata: this.informdatanew },
            });
          }
          if (row.cpricing == "工厂定价") {
            this.$router.push({
              name: "SupInvoiceaddcom",
              params: { rows: row, informdata: this.informdatanew },
            });
          }
        }
      }
    },
  },
};
</script>


